"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var rule_constants_1 = require("./rule-constants");
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.programEmpty,
};
/** Factory that generates Immutable [[IProgramStateCondition]] */
exports.ProgramStateConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IProgramStateCondition]] */
var ImmutableProgramStateCondition = /** @class */ (function (_super) {
    __extends(ImmutableProgramStateCondition, _super);
    function ImmutableProgramStateCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableProgramStateCondition;
}(exports.ProgramStateConditionRecord));
exports.ImmutableProgramStateCondition = ImmutableProgramStateCondition;
//# sourceMappingURL=program-state-condition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/program-state-condition.js
// module id = 1120
// module chunks = 0